const Utils = require('./utils');

// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
const trim = text => {
    const rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    return !text ?
        '' :
        (text + '').replace(rtrim, '');
}

const spanizeText = text => {
        let spanizer = [];

        while (text.length > 0) {
            const arr = text.match(/&[A-Za-z]+\w+;/);
            if (!arr) break;
            if (arr.index > 0) spanizer = spanizer.concat(text.substr(0, arr.index).split(''));
            spanizer.push(arr[0]);
            text = text.substr(arr.index + arr[0].length);
        }
        spanizer = spanizer.concat(text.split(''));

        return '<span>' + spanizer.join('</span><span>') + '</span>';
    }

const spanize = container => {

        let inputHtml = container.innerHTML;
        let outputHtml = '';
        const chs = container.children;
        let ch;
        let n;
        let s;
        for (let i = 0; i < chs.length; i++) {
            ch = chs[i + 1];
            s = ch[0].outerHTML;
            n = inputHtml.search(s);
            if (n > -1) {
                if (n > 0)
                    outputHtml += spanizeText(inputHtml.substr(0, n));
                inputHtml = inputHtml.substr(n + s.length);
                ch.innerHTML(function (index, el1) {
                    return spanizeText(trim(el1));
                })
            }
            outputHtml += ch[i].outerHTML;
        }
        outputHtml += spanizeText(inputHtml.substr(0, n));
        container.innerHTML = outputHtml;
}

const defaults = {
    cssProperty: 'animation',
    delay: 0,
    factor: 2,
    delayRatio: 0.4,
    delayMax: 0.02,
    delayMin: 0.015,
    durationRatio: 0.2,
    durationMax: 0.45,
    durationMin: 0.3,
    reverse: false,
    center: false
};

const applyTiming = (elems, settings) => {
	const params = Utils.extend(defaults, settings);

	elems.forEach(el => {
		let ss = [...el.querySelectorAll('span')];
        let num;
        let s;
        let ssp;

        if (params.reverse)
            ss = ss.reverse();
        if (params.center) {
            ssp = ss.splice(0, Math.floor(ss.length / 2));
            if (params.reverse)
                ss = ss.reverse();
            else
                ssp = ssp.reverse();

        }

        num = ss.length;

        const d0 = params.delayMax;
        const dmin = params.delayMin;
        const r = params.durationRatio;
        const a = (d0 - dmin) * params.factor / (r * r * num * num);

        const t0 = params.durationMax;
        const tmin = params.durationMin;
        const r2 = params.durationRatio;
        const b = (t0 - tmin) * params.factor / (r2 * r2 * num * num);

        let delay = 0;
        for (let i = 0; i < num; i++) {
            s = ss[i];

            delay += a * (i - r * num) * (i - r * num) + dmin;

            s.setAttribute('style', `${params.cssProperty}-duration: ${(b * (i - r2 * num) * (i - r2 * num) + tmin)}s; {params.cssProperty}-delay: ${(params.delay + delay)}s`);
        }

        if (!ssp) return;

        delay = 0;
        ss = ssp;
        num = ss.length;
        for (let i = 0; i < num; i++) {
            s = ss[i];

            delay += a * (i - r * num) * (i - r * num) + dmin;

            s.setAttribute('style', `${params.cssProperty}-duration: ${(b * (i - r2 * num) * (i - r2 * num) + tmin)}s; {params.cssProperty}-delay: ${(params.delay + delay)}s`);
        }
	});
}

module.exports.spanizeText = (selector, settings) => {
    const elems = [...document.querySelectorAll(selector)];
    elems.forEach(container => {
        spanize(container);
    });
    applyTiming(elems, settings);
}


// WEBPACK FOOTER //
// ./js/viscom/viscomjs/utils/spanizer.js